// Form
export const ID_PAZIENTE = "idPaziente";

/* ---------- getElencoProntoSoccorso - JSON ---------- */
export const SORT_OSPEDALE_API = "sorterPosition";
export const ID_OSPEDALE_API = "codOsp";
export const NOME_OSPEDALE_API = "descOsp";
export const NOME_OSPEDALE_BREVE_API = "breveOsp";
export const INDIRIZZO_OSPEDALE_API = "indirizzo";
export const CIVICO_OSPEDALE_API = "civico";
export const CAP_OSPEDALE_API = "cap";
export const COMUNE_OSPEDALE_API = "comune";
export const PROVINCIA_OSPEDALE_API = "provincia";
export const SORT_OSPEDALE_JSON = "sortPos";
export const ID_OSPEDALE_JSON = "id";
export const NOME_OSPEDALE_JSON = "nomeCompleto";
export const NOME_OSPEDALE_BREVE_JSON = "nomeBreve";
export const INDIRIZZO_OSPEDALE_JSON = "indirizzo";
export const CIVICO_OSPEDALE_JSON = "civico";
export const CAP_OSPEDALE_JSON = "cap";
export const COMUNE_OSPEDALE_JSON = "comune";
export const PROVINCIA_OSPEDALE_JSON = "provincia";
/* --------------------------------------------- */
